import { Buildings, Shield, Handshake, IdentificationBadge } from "@phosphor-icons/react";

// Mirrors ACCOUNT_TYPES / CONTACT_ROLES in backend/models.py.
export const ACCOUNT_TYPES = ["customer", "insurer", "broker", "adjuster_firm"];

export const ACCOUNT_TYPE_META = {
    customer: { label: "Client", plural: "Clients", icon: Buildings },
    insurer: { label: "Insurer", plural: "Insurers", icon: Shield },
    broker: { label: "Broker", plural: "Brokers", icon: Handshake },
    adjuster_firm: { label: "Adjusting firm", plural: "Adjusting firms", icon: IdentificationBadge },
};

export function typeMeta(type) {
    return ACCOUNT_TYPE_META[type] || ACCOUNT_TYPE_META.customer;
}

export function TypeBadge({ type, size = 11 }) {
    const meta = typeMeta(type);
    const Icon = meta.icon;
    return (
        <span className="inline-flex items-center gap-1.5">
            <Icon size={size} weight="bold" /> {meta.label}
        </span>
    );
}

export const CONTACT_ROLES = [
    ["", "No role"],
    ["decision_maker", "Decision maker"],
    ["property_manager", "Property manager"],
    ["facilities", "Facilities"],
    ["adjuster", "Adjuster"],
    ["broker", "Broker"],
    ["accounts_payable", "Accounts payable"],
    ["other", "Other"],
];

export const CONTACT_ROLE_LABEL = Object.fromEntries(CONTACT_ROLES);
